<script setup lang="ts">
import { onMounted } from "vue";
import { RouterView } from "vue-router";
import { useAppStore } from "@/stores/app";
import { useUserStore } from "@/stores/user";

const appStore = useAppStore();
const userStore = useUserStore();

onMounted(() => {
  // 初始化窗口监听器
  appStore.initWindowListener();

  // 从本地存储恢复用户状态
  userStore.initFromStorage();
});
</script>

<template>
  <div id="app" class="app-container">
    <RouterView />
  </div>
</template>

<style lang="scss">
html,
body {
  height: 100%;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
    "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: var(--font-size-base, 14px);
  line-height: 1.5;
  color: var(--text-primary);
  background: var(--bg-secondary);
}

#app {
  min-height: 100%;
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

// 页面过渡动画
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all var(--animation-duration-base) ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateX(10px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

// 工具类
.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.flex {
  display: flex;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.full-width {
  width: 100%;
}

.full-height {
  height: 100%;
}

// 响应式工具类
@media (min-width: 768px) {
  .hidden-md-and-up {
    display: none !important;
  }
}

@media (min-width: 992px) {
  .hidden-lg-and-up {
    display: none !important;
  }
}

// 打印样式
@media print {
  .no-print {
    display: none !important;
  }
}
</style>
